import { FC } from 'react';
import { OptionItem, OptionItemLabel } from '../../../style';

const NoResultsFilterItem: FC = () => {
  return (
    <OptionItem data-testid='no-results-filter-item'>
      <span>
        <OptionItemLabel>No Records</OptionItemLabel>
      </span>
    </OptionItem>
  );
};

export default NoResultsFilterItem;
